const LABEL_CHECKED = `tabGroups__label--checked`;
const LABEL_MARGIN_AUTO = `tabs__filterType--marginEnd-auto`;

const tabs = document.querySelector(`.tabs`);
const tabsLabels = tabs.querySelectorAll(`.tabGroups__label`);
const tabsInputs = tabs.querySelectorAll(`.tabs__input`);
const tabsFilter = tabs.querySelectorAll(`.tabs--filter`);
const tabsFilterTypes = tabs.querySelectorAll(`.tabs__filterType`);
const tabsSelect = tabs.querySelector(`.tabGroups__select`);

const setCheckedLabel = (label) => {
  tabsLabels.forEach((tabsLabel) => {
    if (tabsLabel.classList.contains(LABEL_CHECKED)) {
      tabsLabel.classList.remove(LABEL_CHECKED);
    }
  });
  label.classList.add(LABEL_CHECKED);
};

if (tabsFilter) {
  
  const onLabelClick = (evt, index) => {
    setCheckedLabel(evt.target);

    if (index === 0) {
      tabsFilterTypes.forEach((element) => {
        element.style.display = `block`;
      });
    } else {
      let activeTabs = [];

      tabsFilterTypes.forEach((element) => {
        element.classList.remove(LABEL_MARGIN_AUTO);
        if (element.classList.contains(`tabs__filterType--${index}`)) {
          element.style.display = `block`;
          activeTabs.push(element);
        } else {
          element.style.display = `none`;
        }
      });

      activeTabs[activeTabs.length - 1].classList.add(LABEL_MARGIN_AUTO);
    }
    
  };

  tabsLabels.forEach((label, index) => {
    label.addEventListener(`click`, (evt) => {
      onLabelClick(evt, index);
    });
  });
  
  const tabsSelectOnChange = (evt) => {
    tabsLabels[tabsSelect.selectedIndex].click();
  };
  
  tabsSelect.addEventListener(`change`, tabsSelectOnChange);
}